module.exports = __webpack_public_path__ + "media/images/feder-e8fb09cfa2493da09e40616d03388018.png";